import { format, isValid,parse } from 'date-fns'

export function formatDate(iso: string): string {
  if (!iso) return ''
  const d = parse(iso, 'yyyy-MM-dd', new Date())
  return isValid(d) ? format(d, 'dd.MM.yyyy') : iso
}

export function parseDate(display: string): string {
  const d = parse(display, 'dd.MM.yyyy', new Date())
  return isValid(d) ? format(d, 'yyyy-MM-dd') : display
}

export function todayISO(): string {
  return format(new Date(), 'yyyy-MM-dd')
}

export function formatDateTime(iso: string): string {
  if (!iso) return ''
  const d = new Date(iso)
  return isValid(d) ? format(d, 'dd.MM.yyyy HH:mm') : iso
}
